<template>
  <div class="container" @click="bindClick">
    <div class="loading">
      <img
        class="pic"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c585dd740932adea5f963401b06d0a7f.png"
        alt=""
      />
      <div class="text" v-if="type == 'create'">方案生成中…</div>
      <div class="text" v-if="type == 'loading'">加载中...</div>
      <div class="line-container" v-if="type != 'loading'">
        <div
          class="percent"
          :style="{
            width: percent + '%',
            transition: 'width ' + this.delayTime / 1000 + 's linear'
          }"
          ref="percent"
        >
          <div class="linear-line"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      percent: 0,
      type: 'loading',
      delayTime: 2000
    }
  },
  created() {
    let type = this.$route.query.type
    if (type) {
      this.type = type
    }
  },
  mounted() {
    if (this.type == 'create') {
      setTimeout(() => {
        this.$refs.percent.addEventListener('transitionend', () => {
          this.getData()
        })
        this.percent = 100
      }, 200)
    } else if (this.type == 'loading') {
      this.getData()
    }
  },
  methods: {
    //因为该页面没有任何按钮 而app登录在旧版本没有回调，所以给整个页面加上点击事件
    bindClick() {
      this.$betterwe.isLogin(() => {
        this.getData()
      })
    },
    getData() {
      this.$http
        .getBaseApp('member/todayDiet/prevIndex', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (res.data.fan_he_status == 2) {
              this.$router.replace('/eating-today/fill-info')
            } else {
              this.$router.replace({
                path: '/eating-today/home',
                query: {
                  status: res.data.fan_he_status
                }
              })
            }
          } else if (res.code == 700) {
            //未登录
            this.$betterwe.isLogin(() => {
              this.getData()
            })
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  height: 100vh;
  background: #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: center;

  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .pic {
    width: 96px;
    height: 86px;
    object-fit: contain;
    margin-bottom: 16px;
  }

  .text {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
    margin-bottom: 12px;
  }

  .line-container {
    width: 270px;
    height: 4px;
    background: #eeeeee;

    .percent {
      width: 0%;
      height: 100%;
      overflow: hidden;
      border-radius: 5px;

      .linear-line {
        width: 270px;
        height: 100%;
        background: linear-gradient(90deg, #c592ff 0%, #6c5aff 100%);
      }
    }
  }
}
</style>
